const horizontalScroll = (selector: string) =>{
  const slider = document.querySelector(selector) as HTMLElement
  let isDown = false
  let startX: number
  let scrollLeft: number

  slider.addEventListener('mousedown', e => {
    isDown = true
    slider.classList.add('sw-OnScroll')
    startX = e.pageX - slider.offsetLeft
    scrollLeft = slider.scrollLeft
  })
  slider.addEventListener('mouseleave', () => {
    isDown = false
    slider.classList.remove('sw-OnScroll')
  })
  slider.addEventListener('mouseup', () => {
    isDown = false
    slider.classList.remove('sw-OnScroll')
  })
  slider.addEventListener('mousemove', e => {
    if (!isDown) return
    e.preventDefault()
    const x = e.pageX - slider.offsetLeft
    const walk = (x - startX) * 2 //scroll-fast
    slider.scrollLeft = scrollLeft - walk
    console.log(walk)
  })
}

export default horizontalScroll
